<template>
  <div class="engine-oil-recommend" v-if="data">
    <section>
      <header class="header">
        <div class="top flex">
          <div class="title">
            <div class="line" @click="back()">
              <span
                class="font-15"
                v-text="
                  (
                    vehicle_info.brand_name +
                    '-' +
                    vehicle_info.factory_name
                  ).maxLength(30)
                "
              ></span>
              <i class="iconfont icon-arrowR font-10"></i>
            </div>
            <div class="tips font-12" v-if="isVin">
              Vin码识别车型结果仅供参考，请以实际为准
            </div>
          </div>
        </div>
        <!-- Banner列表 -->
        <!-- <banner></banner> -->
        <!-- tab导航 -->
        <div class="nav">
          <div class="cycle" @click="gopage(1)">
            <i class="iconfont icon-rililine_ font-13"></i>
            <span class="font-13">保养周期</span>
          </div>
          <div class="config" @click="gopage(2)">
            <i class="iconfont icon-kepai-peizhi font-13"></i>
            <span class="font-13">车辆配置</span>
          </div>
        </div>
        <!-- 里程数查询（静态） -->
        <div class="search flex">
          <div class="tip">
            <i class="iconfont icon-kepai-gongli font-13"></i>
            <span class="color-gray5 font-13">当前里程数(KM)</span>
          </div>
          <div class="int flex">
            <input
              v-iosInput
              class="color-gray5 font-13"
              type="tel"
              placeholder="请输入"
              v-model="currentMi"
            />
            <span
              class="font-13"
              @click="getMaintenance()"
              v-show="currentMi.length > 0"
              >确认</span
            >
          </div>
        </div>
      </header>

      <div class="main">
        <!-- 机油推荐 -->
        <section class="recommend">
          <div class>
            <header class="flex">
              <div class="title font-14">机油推荐</div>
              <div class="type font-12 color-gray9">
                机油加注量:
                <span
                  v-if="data.vehicle.engine_oil_capacity"
                  v-text="data.vehicle.engine_oil_capacity + 'L'"
                ></span>
                <span v-else v-text="'暂无推荐'"></span>
              </div>
            </header>
            <div class="content flex" v-if="data.goods_list.length > 0">
              <div
                class="item"
                v-for="(item, index) in data.goods_list"
                :key="index"
                @click="goDetail(item)"
              >
                <img :src="item.url" alt />
                <p class="font-12 color-gray2">
                  <span
                    class="chiji font-10 flex"
                    v-if="item.is_best_goods == 1"
                    >最佳</span
                  >
                  {{ item.name }}
                </p>
              </div>
            </div>

            <div
              class="font-12 mark"
              v-if="data.goods_list.length > 0 && data.tips != ''"
            >
              <span>备注说明：</span
              >您正在查询的车型，如配备了满足国6排放标准发动机，则可能需要使用厂家新的机油标准，请务必核对机油加注盖/机舱内说明/车主手册等对机油标准和粘度的要求。
            </div>
          </div>

          <div class="noEngineOil" v-if="data.goods_list.length == 0">
            <img src="@/assets/maintenance/nojy.png" alt />
            <p class="title color-gray5 font-13">暂无机油推荐</p>
            <p class="title-en font-11" @click="back()">
              重新选择其他车辆
              <i class="iconfont icon-arrowR font-11"></i>
            </p>
          </div>
        </section>

        <!-- 其他项目推荐 -->
        <section class="other-commehernd">
          <header class="flex">
            <div class="title font-14">其他保养项目推荐</div>
          </header>
          <div class="content">
            <div class="item" v-for="(item, index) in info" :key="index">
              <div class="preview flex last-no-bd">
                <div class="left flex">
                  <img :src="item.parts_icon" />
                  <div>
                    <p class="font-12 color-gray2">{{ item.parts_name }}</p>
                    <p class="describe font-10 color-gray9">
                      {{ item.parts_attribute }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <!-- 免责声明 -->
    <section>
      <div class="declaration" v-if="isFirst">
        <div class="content-box">
          <div class="text-center font-16 Medium">免责声明</div>
          <div class="font-12 word-break text m-t-30">
            <p>
              在用户选择产品之前，核实车辆配置信息和原厂推荐机油标准是首要前提。
            </p>
            <p>具体用油标准请以车主保养手册或原厂技术公告信息为准。</p>
            <p>
              部分品牌车型在切换成国6排放标准发动机后，会要求使用新的机油标准，如大众、奥迪、保时捷、斯柯达、西亚特、宾利等品牌。对于这部分车型，请务必核实机油加注盖/机舱内说明/车主手册等对机油的要求。
            </p>
            <p>
              正确的机油液位对发动机正常运行至关重要，机油的液位需要在满足原厂测试要求下位于机油尺（或电子机油尺）上下刻度之间，选油助手推荐的加注量仅作为参考。
            </p>
          </div>
          <div class="button-bottom font-14" @click="cancelDeclaration()">
            我已阅读并同意免责声明
          </div>
        </div>
      </div>
    </section>
    <!-- <fab-button v-if="uuid_ready"></fab-button> -->
  </div>
</template>

<script>
import api from "@/apis/maintenance-api";
import Vue from "vue";
import $ from "jquery";
import { setStatistics } from "@/utils/common/index.js";
import { userQueryCarModelRecord } from "@/utils/data-burial";
// import FabButton from "@/components/FabButton.vue";
// import Banner from "@/views/maintenance/components/Banner.vue";
Vue.directive("iosInput", {
  // eslint-disable-next-line no-unused-vars
  bind(el, binding) {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    setTimeout(function () {
      if (isiOS) {
        $("input").css("height", "0.66rem");
      }
    });
  },
});
export default {
  name: "engine-oil-recommend",
  // components: { FabButton, Banner },
  data() {
    return {
      recommendData: "",
      currentMi: "",
      data: null,
      loadData: false,
      isFirst: true,
      isVin: false, // 是否是输入或者扫描vin码进入
      info: [
        {
          parts_name: "机油过滤器",
          parts_attribute: "5000km或6个月/次",
          parts_icon: require("@/assets/maintenance/jyglq.png"),
        },
        {
          parts_name: "空气过滤器",
          parts_attribute: "10000km或12个月/次",
          parts_icon: require("@/assets/maintenance/kqglq.png"),
        },
        {
          parts_name: "空调过滤器",
          parts_attribute: "12个月/次",
          parts_icon: require("@/assets/maintenance/ktglq.png"),
        },
        {
          parts_name: "轮胎",
          parts_attribute: "50000km或48个月/次",
          parts_icon: require("@/assets/maintenance/longtai.png"),
        },
        {
          parts_name: "轮毂",
          parts_attribute: "检查使用情况，必要时更换",
          parts_icon: require("@/assets/maintenance/longdong.png"),
        },
        {
          parts_name: "主雨刮",
          parts_attribute: "6个月/次",
          parts_icon: require("@/assets/maintenance/yugua.png"),
        },
        {
          parts_name: "副雨刮",
          parts_attribute: "6个月/次",
          parts_icon: require("@/assets/maintenance/yugua.png"),
        },
      ],
      vehicle_info: {},
      uuid_ready: false,
    };
  },
  created() {
    this.levelId = this.$route.query.levelId || "";
    this.isVin = this.$route.query.isVin ? true : false;

    let timestamp = Date.parse(new Date());
    let is_first = window.localStorage.getItem("ISFIRSTTIME");
    // 获取是否是第一次进入油量匹配
    if (is_first && timestamp - is_first <= 2592000000) {
      this.isFirst = false;
    }
  },
  async mounted() {
    await this.getMaintenance();
    await this.fetchVehicleDetail();
    await this.queryDataRecord();
    this.uuid_ready = true;
  },
  methods: {
    gopage(type) {
      if (type == 1) {
        this.$router.push({
          path: "/maintenance-cycle",
          query: {
            levelId: this.levelId,
            scheme_id: this.$route.query.scheme_id,
          },
        });
      } else {
        this.$router.push({
          path: "/maintenance-config",
          query: { levelId: this.levelId },
        });
      }
    },
    // 获取车型详情
    async fetchVehicleDetail() {
      try {
        const res = await api.getVehicleDetailApi({
          vehicle_id: this.$route.query.levelId,
        });
        if (res.code === 0) {
          // console.log(res);
          this.vehicle_info = res.data;
          // console.log(res.data);
        } else {
          this.$toast.show({
            showTime: 3,
            message: "获取车型详情失败",
            style: "error",
          });
        }
      } catch (error) {
        error && console.log("获取车型详情失败！");
      }
    },

    // 关闭免责声明
    cancelDeclaration() {
      var timestamp = Date.parse(new Date());
      window.localStorage.setItem("ISFIRSTTIME", timestamp);
      this.isFirst = false;
    },

    //反馈
    feedback() {
      this.$router.push({
        path: "/maintenance-feedback",
        query: { id: "1" },
      });
    },
    // 查询数据记录
    async queryDataRecord() {
      console.log(localStorage.getItem("OILUSER"));
      if (!localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      const uuid = localStorage.getItem("OILUSER");
      const { internal_from, levelId } = this.$route.query;
      const {
        brand_name,
        model_alias,
        factory_name,
        sales_name,
        displacement,
      } = this.vehicle_info;
      const basic_info = {
        choose_vehicle_id: levelId,
        menu_type: 1,
        uuid,
        scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        search_type:
          internal_from === "photo_vin"
            ? 2
            : internal_from === "text_vin"
            ? 3
            : 1,
        brand_name,
        model_alias,
        displacement,
        factory_name,
        sales_name,
      };
      let goods_info = {};
      if (this.data.goods_list.length > 0) {
        const engine_oil_goods_list = this.data.goods_list;
        const high_temp = engine_oil_goods_list.filter(
          (i) => i.is_best_goods === 1
        )[0];
        const low_temp = engine_oil_goods_list.filter(
          (i) => i.is_best_goods === 0
        )[0];
        goods_info = {
          goods_low_mid: low_temp ? low_temp.mid : "",
          goods_low_name: low_temp ? low_temp.name : "",
          goods_high_mid: high_temp ? high_temp.mid : "",
          goods_high_name: high_temp ? high_temp.name : "",
        };
      }
      // console.log(this.data.goods_list, goods_info);
      await userQueryCarModelRecord.apply(this, [basic_info, goods_info]);
    },

    // 获取推荐机油商品列表
    async getMaintenance() {
      let self = this;
      let loading = this.$loading;
      loading.show("加载中...");
      const params = {
        vehicle_id: this.levelId,
        grade_type: this.$route.query.value,
        scheme_id:
          this.$route.query.scheme_id ||
          window.sessionStorage.getItem("OILVERSION"),
      };
      try {
        const res = await api.getOilRecommendGoodsListApi(params);
        loading.hide();
        this.loadData = true;
        if (res.code == 0) {
          this.data = res.data;
          if (res.data.parts_list && res.data.parts_list.length > 0) {
            this.info = res.data.parts_list;
          }
        } else {
          self.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
        this.loadData = true;
      } catch (error) {
        console.log("获取机油推荐商品失败", error);
      }
    },

    // 去机油商品详情
    goDetail(params) {
      const OILSHARE = sessionStorage.getItem("OILSHARE");
      if (JSON.parse(OILSHARE).goods_jump_status !== 1) return;
      this.$router.push({
        path: "/maintenance-good",
        query: {
          goods_id: params.id,
          scheme_id: this.$route.query.scheme_id,
        },
      });
    },

    back() {
      this.$router.push({
        path: "/home",
        query: {
          id:
            this.$route.query.scheme_id ||
            window.sessionStorage.getItem("OILVERSION"),
        },
      });
    },
  },
};
String.prototype.maxLength = function (x) {
  // x英文字节数
  var str = this;
  for (var i = 0; i < this.length; i++) {
    if (this.charCodeAt(i) > 127 || this.charCodeAt(i) == 94) {
      x--;
      if (this.length > x) {
        str = this.substring(0, x) + "...";
      }
    } else {
      if (this.length > x) {
        str = this.substring(0, x) + "...";
      }
    }
  }
  console.log(x);

  return str;
};
</script>

<style lang="less" scoped>
@import "../../style/page/maintenance/recommend.less";
</style>
